
export function toDictionary<TVal, >(
    arr: TVal[],
    keyFunc: ((val: TVal) => number)
): { [key: number]: TVal };

export function toDictionary<TVal, TOut>(
    arr: TVal[],
    keyFunc: ((val: TVal) => number),
    valFunc: ((val: TVal) => TOut)
): { [key: number]: TOut };

export function toDictionary<TVal, TOut>(
    arr: TVal[],
    keyFunc: ((val: TVal) => number),
    valFunc?: ((val: TVal) => TOut)
): { [key: number]: TOut } {

    if (!valFunc)
        valFunc = ((v) => v as any as TOut);

    const result: { [key: number]: TOut } = {};
    for (let val of arr) {
        const key = keyFunc(val);
        result[key] = valFunc(val);
    }

    return result;
}
